import { render, staticRenderFns } from "./Ressources.vue?vue&type=template&id=c6586622&scoped=true&"
import script from "./Ressources.vue?vue&type=script&lang=js&"
export * from "./Ressources.vue?vue&type=script&lang=js&"
import style0 from "./Ressources.vue?vue&type=style&index=0&id=c6586622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6586622",
  null
  
)

export default component.exports